import { t } from 'i18next';
import type { ParseKeys } from 'i18next';
import { rangeKey } from '@/pages/dashboard/dashboard.constants';
import { DONUT_MAX_SEGMENTS } from '@/components/topics-donut/topics-donut.utils';

/** Names the compared span on every KPI tile, as the mockup captions them. */
export function deltaCaption(preset: string | null): string {
  return t(`statistics:deltaCaption.${rangeKey(preset)}`);
}

/** Monday first, as the mockup labels the axis. Keys, not text: `statistics:weekday.labels.*`. */
export const WEEKDAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;

export const WEEKEND_INDEXES: readonly number[] = [5, 6];

/** Derived, not repeated: the donut caps at its palette size, and the two screens must
 * fold at the same point or they show different topics. */
export const TOPIC_BAR_LIMIT = DONUT_MAX_SEGMENTS;

/** Named rows the callback card lists before folding. The payload carries more. */
export const CALLBACK_DEPARTMENT_ROWS = 5;

/** Why no weekday breakdown, so the card can say the true thing rather than one thing. */
export type WeekdayUnavailable = 'hourly' | 'empty' | 'not-measured';

/** One line per cause: a 30-day window with no calls is not a range that is too short. */
export const WEEKDAY_UNAVAILABLE_KEY = {
  hourly: 'weekday.unavailable.hourly',
  empty: 'weekday.unavailable.empty',
  'not-measured': 'weekday.unavailable.notMeasured',
} as const satisfies Record<WeekdayUnavailable, ParseKeys<'statistics'>>;
